<template>
  <div class="getting-started">
    <div class="md-overlay md-fixed md-dialog-overlay" v-if="waitingForFirestore">
      <md-progress-spinner md-mode="indeterminate" class="overlay"></md-progress-spinner>
    </div>
    <div class="md-container">
      <h1>Let's get started</h1>
      <div class="md-layout md-gutter md-alignment-center-center">
        <div class="md-layout-item md-size-70">
          <md-field class="text-center">
            <label for="numOfPlayers">How many players?</label>
            <md-select v-model.number="numOfPlayers" name="numOfPlayers" id="numOfPlayers" type="number">
              <md-option value=2>2</md-option>
              <md-option value=3>3</md-option>
              <md-option value=4>4</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-70">
          <md-field class="text-center">
          <label for="numOfEpidemicCards">How many epidemic cards?</label>
          <md-select v-model.number="numOfEpidemicCards" name="numOfEpidemicCards" id="numOfEpidemicCards" type="number">
            <md-option value=4>4</md-option>
            <md-option value=5>5</md-option>
            <md-option value=6>6</md-option>
          </md-select>
        </md-field>
        </div>
        <div class="md-layout-item md-size-70">
          <md-field class="text-center">
            <label for="url">Title of Game (only lower case letters, numbers, and dashes)</label>
            <md-input type="text" name="title" v-model="url" placeholder="Enter title of game" oninput="this.value = this.value.replace(/[^a-z0-9-]/g, '').replace(/(\..*)\./g, '$1');"></md-input>
          </md-field>
        </div>
        <div v-show="url" class="md-layout-item md-size-70">
          <h2>Copy and share url:</h2>
          <h3>www.pandemicwithfriends.com/{{url}}</h3>
        </div>
        <div class="md-layout-item md-size-70">
          <md-button :disabled="!isDisabled" class="md-raised md-primary" @click="startGame">Start the game!</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import db from '@/firebase/init'
  export default {
    name: "GettingStarted",
    components: {

    },
    data() {
      return {
        numOfPlayers: 0,
        numOfEpidemicCards: 0,
        url: null,
        waitingForFirestore: false
      }
    },
    methods: {
      startGame() {
        this.waitingForFirestore = true;
        db.collection('games').doc(this.url).collection('gameProgress').doc('data').set({
          numOfPlayers: this.numOfPlayers,
          numOfEpidemicCards: this.numOfEpidemicCards,
          startingNewGame: true,
          cardDealt: false,
          lastCardDealt: null,
          currentTurn: 0,
          numOfPlayersSignedUp: 0,
          playedReorderCard: false,
          infectionCardDealt: false,
          lastInfectionCardDealt: null,
          isApocalypse: false,
          cardsDealtToPlayer: 0,
          lastCardDealTo: '',
          playedRemoveDiscard: false,
          discardedCardToRemove: {city: ''},
          secondDiscardedCardToRemove: {city: ''},
          numOfDiscardedCardsRemoved: 0
        }).then(()=>{
          this.waitingForFirestore = false;
          this.$router.push({ name: 'Play', params: {  url: this.url }})
        })
      }
    },
    computed: {
      isDisabled(){
        return this.url && this.numOfPlayers && this.numOfEpidemicCards
      }
    }
  }
</script>

<style scoped>
  h1, h2, h3 {
    color: #fff;
  }
  .overlay {
    position: absolute;
    top:50%;
  }

</style>